const catalogCache = new Map();

export function manifestPathForVersion(version) {
  return `/mini-tasks/memory/manifest.v${Number(version)}.json`;
}

export async function loadMemoryCatalog(version) {
  const catalogVersion = Number(version);
  if (!catalogCache.has(catalogVersion)) {
    catalogCache.set(
      catalogVersion,
      fetch(manifestPathForVersion(catalogVersion), { cache: 'force-cache' })
        .then((response) => {
          if (!response.ok) throw new Error('Hafıza kartları yüklenemedi.');
          return response.json();
        })
        .then((manifest) => {
          const assets = (manifest.categories || [])
            .flatMap((category) =>
              (category.assets || []).map((asset) => ({
                ...asset,
                categoryId: category.id,
                src: `${manifest.basePath}/${asset.file}`,
              })),
            )
            .sort((left, right) => left.id.localeCompare(right.id));
          if (Number(manifest.version) !== catalogVersion || assets.length < 16) {
            throw new Error('Hafıza kart kataloğu geçerli değil.');
          }
          return { ...manifest, assets };
        }).catch((error) => {
          catalogCache.delete(catalogVersion);
          throw error;
        }),
    );
  }
  return catalogCache.get(catalogVersion);
}

export function clearMemoryCatalogCache() {
  catalogCache.clear();
}
